'use strict';

export class PhoneVerification {
	constructor($root) {
		this.valid_msg_id = false;
		this.msg_id = "";
		this.file = null;
		this.email = "";
		this.phone = "";
		this.is_verified = false;
		this.is_deleted = false;
		this.$root = $root;

		const $active_feedback = this.$root.find(".js-faq_meta_results__question.active")
			.find(".js-faq_meta_results__feedback_wrapper");

		yalwa.basics.hide($active_feedback);

		this.actions = {
			email: this.handle_email_submission.bind(this),
			phone: this.handle_phone_submission.bind(this),
		};

		this.init_event_listeners();
	}

	init_event_listeners() {
		this.$root.find(".js-faqpa_wrong_id_no").on("click", this.handle_wrong_id_no.bind(this));
		this.$root.find(".js-faqpa_wrong_id_yes").on("click", () => yalwa.basics.reload());

		const $input = this.$root.find(".js-faqpa_phone_abuse_input");
		$input.on("input", this.validate_input.bind(this));
		$input.on("focus", function () {
			yalwa.basics.show(jQuery(this).parent().next());
		});
		$input.on("enterdown", this.handle_submit_input.bind(this));

		this.$root.find(".js-faqpa_submit_button").on("click", this.handle_submit_input.bind(this));
		this.$root.find(".js-faqpa_verification_no_sms").on("click", this.handle_no_sms_click.bind(this));
		this.$root.find(".js-faqpa_verification_number_blocked").on("click", this.handle_number_blocked_click.bind(this));

		const $visible_form = this.$root;

		$visible_form.find(".js-faqpa_upload_proof").on("click", () => {
			$visible_form.find(".js-faqpa_input_proof_file").click();
		});

		$visible_form.find(".js-faqpa_input_proof_file").on("change", this.handle_file_change.bind(this));
	}

	show_phone_form() {
		yalwa.basics.show(this.$root.find(".js-faqpa_form_phone"));
		yalwa.basics.show(this.$root.find(".js-faqpa_faq_phone_no"));
		yalwa.basics.hide(this.$root.find(".js-faqpa_yes_no_buttons"));
	}

	handle_wrong_id_no() {
		yalwa.basics.hide(this.$root.find(".js-faqpa_wrong_id_no_button"));
		yalwa.basics.show(this.$root.find(".js-faqpa_faq_phone_try_again_no"));
		yalwa.basics.show(this.$root.find(".js-faqpa_back_to_locanto"));
	}

	validate_input(e) {
		const $input = jQuery(e.currentTarget);
		const val = $input.val().trim();
		const type = $input.attr("type");
		const $parent_div = $input.parent().parent();
		const $submit_btn = $input.next();

		const is_valid =
			type === "text" ? /^\d+$/.test(val) :
			type === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) :
			false;

		this.valid_msg_id = is_valid;
		$parent_div.toggleClass("phone_abuse_error", !is_valid);
		yalwa.basics.toggle($submit_btn, is_valid);
	}

	handle_submit_input(e) {
		const $parent = jQuery(e.currentTarget).parent();
		const type = $parent.data("type");
		if (this.actions[type]) this.actions[type](e);
	}

	handle_no_sms_click() {
		yalwa.basics.hide(this.$root.find(".js-faqpa_yes_no_buttons"));
		yalwa.basics.show(this.$root.find(".js-faqpa_verification_section_no_sms"));
		yalwa.basics.show(this.$root.find(".js-faqpa_back_to_locanto"));
		yalwa.basics.show($active_feedback);
	}

	handle_number_blocked_click() {
		yalwa.basics.hide(this.$root.find(".js-faqpa_yes_no_buttons"));
		yalwa.basics.show(this.$root.find(".js-faqpa_verification_section_number_blocked"));
		yalwa.basics.show(this.$root.find(".js-faqpa_back_to_locanto"));
		yalwa.basics.show($active_feedback);
	}

	handle_email_submission(e) {

		if (this.is_submitting) return;
		this.is_submitting = true;

		this.email = this.$root.find(".js-faqpa_input_email").val().trim();
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
			this.is_submitting = false;
			return;
		}

		const $parent = jQuery(e.currentTarget).parent();
		const form_data = new FormData();
		if (this.phone) form_data.append("phone", this.phone);
		form_data.append("file", this.file);
		form_data.append("email", this.email);
		form_data.append("message", "Phone reverification request");
		form_data.append("action", "phone_verification_faq");
		form_data.append("sub_action", "send_message");
		form_data.append("csrf_bust", yalwa.v.csrf_bust);

		jQuery.ajax({
			type: "POST",
			url: "/api/ajax/general/",
			data: form_data,
			processData: false,
			contentType: false,
			dataType: "json",
		}).done((response) => {
			const $status = this.$root.find(".js-faqpa_upload_status");
			if (response.success) {
				$parent.html(`<div class="faq_phone_abuse_form__question_section_answer">${this.email}</div>`);
				yalwa.basics.show(this.$root.find(".js-faqpa_thank_you_for_email"));
				yalwa.basics.show(this.$root.find(".js-faqpa_back_to_locanto"));
				yalwa.basics.show(this.$root.find(".js-faq_meta_results__question.active")
					.find(".js-faq_meta_results__feedback_wrapper"));
			} else {
				$status.text("Upload failed. Please try again.").css("color", "red");
			}
		}).always(() => {
			this.is_submitting = false;
		});
	}

	handle_phone_submission(e) {
		e.stopPropagation();

		this.phone = this.$root.find(".js-faqpa_input_phone").val().trim();
		const $parent = jQuery(e.currentTarget).parent();

		if (!this.valid_msg_id || this.phone.length < 6) {
			if (this.phone.length < 6) {
				const error_msg = this.$root.find(".js-faqpa_phone_is_short").html();
				yalwa.basics.toast({ message: error_msg, type: "error" });
			}
			return;
		}

		yalwa.basics.show(this.$root.find(".js-faqpa_information_check"));
		yalwa.basics.hide($parent.next());

		$parent.html(`<div class="faq_phone_abuse_form__question_section_answer">${this.phone}</div>`);

		jQuery.ajax({
			type: "POST",
			url: "/api/ajax/general/",
			dataType: "json",
			data: {
				action: "phone_verification_faq",
				sub_action: "verify_phone",
				phone: this.phone,
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done((response) => {
			setTimeout(() => {
				const $question = this.$root.find(".js-faq_meta_results__question.active")
					.find(".js-faq_meta_results__feedback_wrapper");

				if (response.success) {
					this.is_verified = !!response.is_verified;
					this.is_deleted = !!response.is_deleted;

					if (this.is_verified) {
						if (this.is_deleted) {
							yalwa.basics.show(this.$root.find(".js-faqpa_account_deleted_section"));
							yalwa.basics.show(this.$root.find(".js-faqpa_back_to_locanto"));
						} else {
							yalwa.basics.show(this.$root.find(".js-faqpa_proof_upload_section"));
						}
					} else {
						yalwa.basics.show(this.$root.find(".js-faqpa_phone_not_verified_section"));
					}
				} else {
					yalwa.basics.show(this.$root.find(".js-faqpa_phone_not_verified_section"));
				}

				yalwa.basics.show($question);
			}, 2000);
		});
	}

	handle_file_change() {
		const $file_input = this.$root.find(".js-faqpa_input_proof_file")[0];
		this.file = $file_input?.files?.[0] || null;

		const $upload_button_text = jQuery(".js-faqpa_upload_proof span");
		$upload_button_text.text(this.file.name);

		this.$root.find(".js-faqpa_upload_proof").addClass("upload-button--uploaded");
		yalwa.basics.hide(this.$root.find(".js-faqpa_upload_proof").prev());
		yalwa.basics.hide(this.$root.find(".js-faqpa_upload_proof").next());

		if (this.file) {
			yalwa.basics.show(this.$root.find(".js-faqpa_information_verified"));
		}
	}
}